// import Navbar from "../../components/navbar/Navbar";
// import Footer from "../../components/footer/Footer";
// import Header from "../../components/header/Header";
import weeklyCampaign from "../../assets/images/weeklyCampaign.svg";
import { IoHeart } from "react-icons/io5";
import { IoIosHeartEmpty } from "react-icons/io";
import { calculateDiscountedPrice, renderStars } from "../../utils/functions.tsx";
import { useState, useCallback, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import styles from "./WeeklyCampaigns.module.css";
import { useNavigate } from 'react-router-dom';
import { getFetcher } from "../../../api/fetchers.ts";
import { endpoints } from "../../../api/endpoints.ts";
import { useUser } from '../../context/UserContext';
import { BiChevronsRight } from "react-icons/bi";
import Spinner from "../../components/spinner/Spinner.tsx";
import { useCurrency } from "../../context/CurrencyContext.tsx";
import { useLanguage } from "../../context/LanguageContext.tsx";

const WeeklyCampaigns = () => {
    const {t} = useLanguage();
    const { exchangeRate } = useCurrency();
    const [clickedProduct] = useState<number | null>(null);
    const [weeklyProducts, setWeeklyProducts] = useState<any[]>([]);
    const [favoriteProductIds, setFavoriteProductsIds] = useState<Set<string>>(new Set());
    const [loading, setLoading] = useState(false);

    const { user, addFavoriteProduct, removeFavoriteProduct } = useUser();
    const navigate = useNavigate();




    // LIKE PRODUCT TOGGLE
    const toggleLike = useCallback(async (id: string, productName: string) => {
        const isLiked = favoriteProductIds.has(id);

        try {
            if (isLiked) {
                await removeFavoriteProduct(id);
                setFavoriteProductsIds((prevIds: Set<string>) => {
                    const newSet = new Set(prevIds);
                    newSet.delete(id);
                    return newSet;
                });
                toast.info(`${productName} ${t('toastMessage', 'addBasketFavInfo')}`);
            } else {
                await addFavoriteProduct(id);
                setFavoriteProductsIds(prevIds => new Set(prevIds).add(id));
                toast.success(`${productName} ${t('toastMessage', 'addBasketFavSuc')}`);
            }
        } catch (error) {
            toast.error(t('toastMessage', 'addBasketFavErr'));
        }
    }, [favoriteProductIds, addFavoriteProduct, removeFavoriteProduct]);

    // Fetch weeklyProducts
    useEffect(() => {
        const fetchWeeklyProducts = async () => {
            setLoading(true);
            try {
                const response = await getFetcher(endpoints.products.getWeeklyCampaigns);
                if (response.result) {
                    setWeeklyProducts(response.weeklyProducts);
                    setLoading(false);
                } else {
                    console.log(response.message);
                }
            } catch (error) {
                console.error("Error fetching weekly products:", error);
            }
        };
        fetchWeeklyProducts();
    }, []);


    // Fetch user favorites
    useEffect(() => {
        if (user?.id) {
            const fetchUserFavorite = async () => {
                try {
                    const response = await getFetcher(`${endpoints.user.getFavorites}/${user.id}`);
                    if (response.result) {
                        const favoritesSet: any = new Set(response.favoriteProducts.map((product: any) => product.product.id));
                        setFavoriteProductsIds(favoritesSet);
                    } else {
                        console.log(response.message);
                    }
                } catch (error) {
                    console.error("Error fetching favorites data:", error);
                }
            };
            fetchUserFavorite();
        }
    }, [user]);

    if (loading) {
        return <div><Spinner /></div>
    }

    return (
        <div className="flex flex-col min-h-screen">
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            {/* <Header />
            <Navbar /> */}
            <main className="flex-grow p-6 mb-20 overflow-y-auto">
                <div className=" ">
                    {/* HEADER */}
                    <div className="flex justify-center ">
                        <img src={weeklyCampaign} alt="weeklyCampaign" className="w-full " />
                    </div>
                    {/* PRODUCTS */}
                    <section className={`flex-grow self-center ${styles.scrollableSection}`}>
                        <div className="flex flex-wrap items-center justify-center gap-2">
                            {weeklyProducts.length > 0 ?

                                (weeklyProducts?.map((item) => {
                                    const images = (item.product.images);
                                    return (
                                        <div key={item.product.id} className="w-80 lg:w-96 h-full p-4">
                                            <div className="h-full flex flex-col justify-between overflow-hidden">
                                                <div
                                                    className="w-full flex justify-center rounded-lg relative py-6 bg-color-product-bg">
                                                    <img src={images[0]} alt={item.product.name}
                                                        className="h-64 object-cover rounded-t-lg cursor-pointer"
                                                        onClick={() => navigate(`/product-detail/${item.product.id}`)} />
                                                    <button className="absolute top-2 right-2 rounded-full bg-transparent"
                                                        onClick={() => toggleLike(item.product.id, item.product.name)}>
                                                        {favoriteProductIds.has(item.product.id) ? (
                                                            <IoHeart className="text-primary-color text-3xl mt-2 mr-2" />
                                                        ) : (
                                                            <IoIosHeartEmpty className="text-primary-color text-3xl mt-2 mr-2" />
                                                        )}
                                                    </button>
                                                </div>
                                                <div className="p-4 flex flex-col justify-between flex-grow">
                                                    <h2 className="text-lg font-bold truncate cursor-pointer" onClick={() => navigate(`/product-detail/${item.product.id}`)}>{item.product.name}</h2>
                                                    <div className="flex items-center mt-2">
                                                        <div className="flex items-center">{renderStars(item.product.rating)}</div>
                                                    </div>
                                                    <div className="w-full mt-4 flex justify-between items-end">
                                                        <div className="flex gap-2">
                                                            {item?.product?.discount > 0 ? (
                                                                <>
                                                                    <p className="text-lg lg:text-2xl font-semibold ">₺{calculateDiscountedPrice(item.product.price, item.product.discount, 0,exchangeRate)}</p>
                                                                    <p className="text-lg lg:text-2xl font-semibold line-through text-gray-500">₺{item.product.price}</p>
                                                                </>
                                                            ) : (
                                                                <p className="text-lg lg:text-2xl font-semibold">₺{item.product.price}</p>
                                                            )}
                                                            <div
                                                                className="w-12 h-8 flex items-center justify-center text-sm bg-red-200 text-red-700 px-4 rounded-3xl">
                                                                {item.product.discount}%
                                                            </div>
                                                        </div>
                                                        <button
                                                            className={`text-white text-lg md:text-xl font-bold p-2 rounded-full shadow-md ${clickedProduct === item.product.id ? 'bg-green-500' : 'bg-primary-color'}`}
                                                            onClick={() => navigate(`/product-detail/${item.product.id}`)}>
                                                            <BiChevronsRight />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })) : null}
                        </div>
                    </section>
                </div>
            </main>
            {/* <Footer /> */}
        </div>
    );
};

export default WeeklyCampaigns;